import { jsx, Fragment, jsxs } from 'react/jsx-runtime';
import { styled, Collapse } from '@mui/material';
import { Checkbox } from './components/Checkbox.js';
import { ItemLabel } from './components/ItemLabel.js';
import { ArrowButton } from './components/ArrowButton.js';
import { Header } from './components/Header.js';
import { flattenChildren } from '../utils.js';

const Container = styled('div', {
    shouldForwardProp: (prop) => prop === 'children' || prop === 'key' || prop === 'data-testid',
}) `
  width: max-content;
  min-width: 100%;
`;
const RecursiveTreeViewItem = ({ items, onItemToggled, expandedItems, onItemChecked, checkedItems, selectable, }) => {
    return (jsx(Fragment, { children: items.map((parent) => {
            var _a;
            const isItemExpanded = expandedItems.includes(parent.id);
            const isItemChecked = checkedItems.includes(parent.id);
            const childrenIds = parent.children && parent.children.length > 0
                ? flattenChildren(parent.children).map((child) => child.id)
                : [];
            const checkedChildren = childrenIds.filter((childId) => checkedItems.includes(childId));
            const hasChildren = !!((_a = parent.children) === null || _a === void 0 ? void 0 : _a.length);
            const hasCheckedChildren = checkedChildren.length > 0;
            const allChildrenAreChecked = hasCheckedChildren === true && childrenIds.length === checkedChildren.length;
            return (jsxs(Container, Object.assign({ "data-testid": parent.id, isTitle: parent.isTitle }, { children: [jsxs(Header, Object.assign({ hasBorderTop: parent.isTitle, disabled: parent.disabled, reduceOpacity: parent.hidden }, { children: [jsx(ArrowButton, { show: hasChildren, expanded: isItemExpanded, onClick: () => onItemToggled(parent.id) }), selectable && (jsx(Checkbox, { id: parent.id, checked: isItemChecked, disabled: parent.disabled, indeterminate: isItemChecked && hasChildren && !allChildrenAreChecked, onChange: checked => {
                                    onItemChecked(parent.id, checked);
                                }, hasChildren: hasChildren })), jsx(ItemLabel, { label: parent.label, icon: parent.icon, isTitle: parent.isTitle })] })), jsx(Collapse, Object.assign({ in: isItemExpanded, sx: { paddingLeft: '22px' }, unmountOnExit: true }, { children: hasChildren && (jsx(RecursiveTreeViewItem, { expandedItems: expandedItems, items: parent.children, onItemToggled: onItemToggled, onItemChecked: onItemChecked, checkedItems: checkedItems, selectable: selectable })) }), parent.id)] }), parent.id));
        }) }));
};

export { RecursiveTreeViewItem };
//# sourceMappingURL=RecursiveTreeViewItem.js.map
